import React, { useState, useEffect } from "react";
import { Wrapper } from "./ExpensesDetails.styled";
import { Row, Col, Button , Spin} from "components/common";
import { callGetApiWithAuth } from "utils/api";
import { useHistory } from "react-router";

const ExpensesDetails = () => {
  const history = useHistory();
  const [allUsers, setUsersData] = useState([]);
  const [expenseCategory, setExpenseCategory] = useState([]);
  const [dataExpense, setDataExpense] = useState([]);
  const [expenseDetails, setExpenseDetails] = useState(null);
  const [leads, setLeads] = useState([]);
  const [details, setDetails] = useState(null);
  const [expenseId, setExpenseId] = useState("");
  const [loader, setLoader] = useState(false);

  const getExpenseDataApi = () => {
    callGetApiWithAuth("getAllExpenses", onSuccessGetApi, onFailedGetApi);
  };

  const getAllUserApi = () => {
    callGetApiWithAuth("allUsers", onSuccessAllUserApi, onFailedAllUserApi);
  };

  const getExpenseCategoryApi = () => {
    callGetApiWithAuth(
      "getAllExpensCategory",
      onSuccessExpenseCategoryApi,
      onFailedExpenseCategoryApi
    );
  };

  const getLeadsApi = () => {
    callGetApiWithAuth("leads", onSuccessLeadsApi, onFailedLeadsApi);
  };

  const onSuccessLeadsApi = (data) => {
    setLeads(data?.hits);
    setLoader(false);
  };

  const onFailedLeadsApi = (err) => {
    console.log(err);
    setLoader(false);
  };
  const onSuccessExpenseCategoryApi = (data) => {
    setExpenseCategory(data);
    setLoader(false)
  };

  const onFailedExpenseCategoryApi = (err) => {
    console.log(err);
  };

  const onSuccessAllUserApi = (data) => {
    setUsersData(data);
    setLoader(false);
  };

  const onFailedAllUserApi = (err) => {
    console.log(err);
    setLoader(false);
  };

  const onSuccessGetApi = (data) => {
    data?.map((el) => {
      if (el.id == history?.location?.pathname.split("/")[2]) {
        setDetails(el);
      }
    });
    setDataExpense(data);
    setLoader(false);
  };

  const onFailedGetApi = (err) => {
    console.log(err);
  };

  useEffect(() => {
    let id = history?.location?.pathname.split("/")[2];
    if (id) {
      getExpenseDataApi();
      setExpenseId(id);
      getAllUserApi();
      getExpenseCategoryApi();
      getLeadsApi();
      setLoader(true);
    }
  }, []);

  let leadName = leads?.filter((el) => el.objectID == details?.leadId)?.[0];

  return (
    <Wrapper>
    {loader ? (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginTop: 20,
          }}
        >
          <Spin />
        </div>
        ) : (
      <Row gutter={[20, 20]}>
        <Col xs={24} lg={12} className="lead-status-container">
          <div className="lead-form-row">
            <Row gutter={[10, 10]}>
              <Col span={24}>
                <Row>
                  <Col span={8}>
                    <label htmlFor="" className="label-conatiner">
                      <p>Invoice Date:</p>
                    </label>
                  </Col>
                  <Col span={16}>
                    <p className="text-conatiner">{details?.invoiceDate}</p>
                  </Col>
                </Row>
              </Col>
              <Col span={24}>
                <Row>
                  <Col span={8}>
                    <label htmlFor="" className="label-conatiner">
                      <p>Description:</p>
                    </label>
                  </Col>
                  <Col span={16}>
                    <p className="text-conatiner">{details?.description}</p>
                  </Col>
                </Row>
              </Col>
              <Col span={24}>
                <Row>
                  <Col span={8}>
                    <label htmlFor="" className="label-conatiner">
                      <p>Category Name:</p>
                    </label>
                  </Col>
                  <Col span={16}>
                    <p className="text-conatiner">
                      {expenseCategory?.filter((el) => el.id == details?.category)?.[0]?.name}
                    </p>
                  </Col>
                </Row>
              </Col>
              <Col span={24}>
                <Row>
                  <Col span={8}>
                    <label htmlFor="" className="label-conatiner">
                      <p>Amount:</p>
                    </label>
                  </Col>
                  <Col span={16}>
                    <p className="text-conatiner">${details?.amount}</p>
                  </Col>
                </Row>
              </Col>
              <Col span={24}>
                <Row>
                  <Col span={8}>
                    <label htmlFor="" className="label-conatiner">
                      <p>Status: </p>
                    </label>
                  </Col>
                  <Col span={16}>
                    <p className="text-conatiner">{details?.status}</p>
                  </Col>
                </Row>
              </Col>
              <Col span={24}>
                <Row>
                  <Col span={8}>
                    <label htmlFor="" className="label-conatiner">
                      <p>Lead:</p>
                    </label>
                  </Col>
                  <Col span={16}>
                    <p className="text-conatiner">{leadName?.firstName} {leadName?.lastName}</p>
                  </Col>
                </Row>
              </Col>
              <Col span={24}>
                <Row>
                  <Col span={8}>
                    <label htmlFor="" className="label-conatiner">
                      <p>User:</p>
                    </label>
                  </Col>
                  <Col span={16}>
                    <p className="text-conatiner">
                      {
                        allUsers.filter(
                          (user) => user.id === details?.userId
                        )?.[0]?.name
                      }
                    </p>
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
        </Col>
      </Row>
      )}
    </Wrapper>
  );
};

export default ExpensesDetails;
